import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class TopNews extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const content = this.props.content || [];

        if (!content.length) return null;

        return (
            <div className={styles.topNews}>
                {content.slice(0, 6).map((item, index) => (
                    <article key={item.id || index}>
                        <h3 className={index === 0 ? styles.first_title : styles.second_title}>
                            <a href={item.url} title={item.title} target="_blank" rel="noopener noreferrer">
                                {item.title}
                            </a>
                        </h3>
                    </article>
                ))}
            </div>
        );
    }
}

export default errorBoundary(TopNews);
